(function () {
  const calendars = document.querySelectorAll("[data-sjv-calendar]");
  if (!calendars.length) return;

  const statusLabels = {
    open: "Ouvert 10h-18h",
    holiday: "Férié ouvert 10h-18h",
    "no-meal": "Ouvert 10h-18h, restaurant fermé",
    closed: "Fermé",
    school: "Fermé, groupes scolaires uniquement",
    office: "Parc fermé, bureau ouvert",
  };

  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const availableMonths = [2, 3, 4, 5, 6, 7, 8, 9];
  const today = window.SJVSeasonCalendar.today();

  const calendarStatuses = window.SJVSeasonCalendar.opening;

  function isoDate(year, month, day) {
    return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  calendars.forEach((calendar) => {
    let shownMonth =
      today.getFullYear() === 2027 && availableMonths.includes(today.getMonth())
        ? today.getMonth()
        : availableMonths[0];

    const daysTarget = calendar.querySelector("[data-sjv-calendar-days]");
    const labelTarget = calendar.querySelector("[data-sjv-calendar-label]");
    const todayTarget = calendar.querySelector("[data-sjv-calendar-today]");
    const prev = calendar.querySelector("[data-sjv-calendar-prev]");
    const next = calendar.querySelector("[data-sjv-calendar-next]");

    function renderCalendar() {
      if (!daysTarget || !labelTarget) return;

      const year = 2027;
      const firstDay = new Date(year, shownMonth, 1);
      const daysInMonth = new Date(year, shownMonth + 1, 0).getDate();
      const offset = (firstDay.getDay() + 6) % 7;
      daysTarget.innerHTML = "";
      if (prev) prev.disabled = shownMonth === availableMonths[0];
      if (next) next.disabled = shownMonth === availableMonths[availableMonths.length - 1];
      labelTarget.textContent = `${monthNames[shownMonth]} 2027`;

      for (let i = 0; i < offset; i += 1) {
        daysTarget.appendChild(document.createElement("span"));
      }

      for (let day = 1; day <= daysInMonth; day += 1) {
        const key = isoDate(year, shownMonth, day);
        let status = calendarStatuses[key] || "closed";

        const date = new Date(year, shownMonth, day);
        const isToday = date.toDateString() === today.toDateString();
        const button = document.createElement("button");
        button.type = "button";
        button.className = `sjv-calendar-day status-${status}${isToday ? " is-today" : ""}`;
        button.innerHTML = `<span>${day}</span><small>${statusLabels[status]}</small>`;
        button.setAttribute("aria-label", `${day} ${monthNames[shownMonth]} 2027 - ${statusLabels[status]}`);
        daysTarget.appendChild(button);
      }

      if (todayTarget) {
        const currentDate = window.SJVSeasonCalendar.today();
        const todayKey = isoDate(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const todayStatus = calendarStatuses[todayKey] || "closed";
        todayTarget.textContent = window.SJVSeasonCalendar.todayNotice(currentDate) || statusLabels[todayStatus];
      }
    }

    prev?.addEventListener("click", () => {
      const index = availableMonths.indexOf(shownMonth);
      shownMonth = availableMonths[Math.max(0, index - 1)];
      renderCalendar();
    });

    next?.addEventListener("click", () => {
      const index = availableMonths.indexOf(shownMonth);
      shownMonth = availableMonths[Math.min(availableMonths.length - 1, index + 1)];
      renderCalendar();
    });

    renderCalendar();
  });
})();
